import { render, staticRenderFns } from "./slettementList.vue?vue&type=template&id=8a2bcad8&"
import script from "./slettementList.vue?vue&type=script&lang=js&"
export * from "./slettementList.vue?vue&type=script&lang=js&"
import style0 from "./slettementList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports